import { render, staticRenderFns } from "./profileManagement.vue?vue&type=template&id=5e71edf9&scoped=true&"
import script from "./profileManagement.vue?vue&type=script&lang=js&"
export * from "./profileManagement.vue?vue&type=script&lang=js&"
import style0 from "./profileManagement.vue?vue&type=style&index=0&id=5e71edf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e71edf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e71edf9')) {
      api.createRecord('5e71edf9', component.options)
    } else {
      api.reload('5e71edf9', component.options)
    }
    module.hot.accept("./profileManagement.vue?vue&type=template&id=5e71edf9&scoped=true&", function () {
      api.rerender('5e71edf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/profileManagement.vue"
export default component.exports